/*
 * @Author: Tina Huang
 * @Date: 2024-02-21 12:21:07
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2025-10-17 16:38:55
 * @Description:
 */

import styles from './detail.module.less'
import ArrowImg from '@/assets/svgs/arrow.ce4a294b.png'
import { useEffect, useState, useMemo, SetStateAction, useRef, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { Picks as picks } from '@/constants/picks'
import { useNavigate, useLocation } from 'react-router-dom'
import { Col, Space, Rate, Button, Tag, Image, Modal, Popconfirm, message, Input, Flex, QRCode, Carousel, Tooltip, Result } from 'antd'
import { EllipsisOutlined, ExclamationCircleFilled, EyeOutlined, GlobalOutlined } from '@ant-design/icons'
import Author from '@/components/Author'
import { PickListCard } from './picks-list'
import { init } from '@waline/client'
import '@waline/client/style'
import { checkVIP, is_weixn } from '@/utils'
import { useOffStatus } from './pick-items'
import moment from 'moment'
import Gift from '@/assets/svgs/gift'
import CopyToClipboard from 'react-copy-to-clipboard'
moment.locale('zh-cn') //汉化

export default function PickDetail(props: { from?: string }) {
  const { from } = props
  const { id, code } = useParams()
  const navigate = useNavigate(),
    location = useLocation()
  const [messageApi, contextHolder] = message.useMessage()

  const [item, setItem] = useState<any>()
  const [lock, setLock] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isCodeOpen, setIsCodeOpen] = useState(false)
  const [linkId, setLinkId] = useState('')
  const [tempCode, setTempCode] = useState(code || '')
  const [isCheck, setIsCheck] = useState(true) // 是否通过code验证
  const isMobile = window.innerWidth <= 750
  const [offCountdown, setOffCountdown] = useState('')
  const [result, setResult] = useState<any>('default')
  const [openConfirm, setOpenConfirm] = useState<boolean>(false)
  const [showWechatMark, setShowWechatMark] = useState(false)
  const [isUnlocking, setIsUnlocking] = useState(false)

  const CountdownRef = useRef<any>(null)

  const star = Math.round(Math.random() * 50) + 5

  const { offStatus } = useOffStatus(item)

  // const bread = useMemo(() => {
  //   return [
  //     // {title: '汪汪汪世界', path: ''},
  //     { title: '模板', path: '/picks' },
  //     { title: item?.flowus ? 'FlowUs模板' : 'Notion模板', path: item?.flowus ? '/flowus' : '/pick' },
  //   ]
  // }, [item])

  const UseSteps = (props: { flowus?: boolean }) => {
    const { flowus } = props
    if (flowus) {
      return (
        <>
          <p>
            第一步：在
            <a href="https://flowus.cn/login/?code=YJDF4B" className="font-bold text-blue-500">
              FlowUs息流官网
            </a>
            注册自己的账号
          </p>
          <p>
            第二步：在当前浏览器
            <a href="https://flowus.cn/login/?code=YJDF4B" className="font-bold text-blue-500">
              登录
            </a>
            自己的FlowUs账号
          </p>
          <p>
            第三步：点击下方的<strong>「拷贝到自己空间」</strong>按钮进行模板链接访问
          </p>
          <p>第四步：打开模板之后请点击模板右上角的「拷贝到」按钮进行拷贝</p>
          <p>
            <small className="text-rose-400">PS：若右上角无拷贝到按钮请查看三点或者右下角的图标</small>
          </p>
        </>
      )
    } else {
      return (
        <>
          <p>
            第一步：在
            <a href="www.notion.so" className="font-bold text-blue-500">
              Notion官网
            </a>
            注册自己的Notion账号
          </p>
          <p>第二步：在当前浏览器登录自己的Notion账号</p>
          <p>
            第三步：点击下方的<strong>「拷贝到自己空间」</strong>按钮进行模板拷贝
          </p>
        </>
      )
    }
  }

  const countdown = (time: string) => {
    const remain = new Date(time).getTime() - new Date().getTime()
    return moment(remain).format('DD天 HH:mm:ss')
  }
  const initWaline = useCallback(() => {
    if (isMobile) return

    init({
      el: '#waline',
      // serverURL: 'https://widverse-comments.vercel.app',
      serverURL: 'https://waline-1-x3506913.deta.app/',
      path: window.location.href,
    })
  }, [isMobile])

  const initItem = useCallback(() => {
    const _item = picks.find((item) => item.id === Number(id))
    if (!_item) return setResult('404')
    if (_item?.hide && code !== 'htt78') navigate(-1)
    initWaline()
    if (from !== 'vip') {
      if (_item?.lock) setLock(true)
      if (item?.code) {
        console.log(isCheck)
        setIsCheck(false)
        if (code && code === item?.code) setIsCheck(true)
        else setIsCodeOpen(true)
      }
    }
    const __time = Math.floor((new Date().getTime() / 1000 - 1705812265) / (24 * 60 * 60)),
      __rand = Math.floor(Math.random() * 100 + 200),
      _t = new Date(),
      __r = +`${_t.getFullYear() % 2000}${_t.getMonth()}${_t.getDate()}${_t.getHours()}${_t.getMinutes()}`

    setItem({ ..._item, views: Math.round((__time * __r) / 200000) + __rand })
    document.title = _item?.full_title || _item?.title || document.title
  }, [code, from, id, initWaline, isCheck, item?.code, navigate])

  useEffect(() => {
    if (!id) navigate(-1)
    window.scrollTo({ top: 0 })
    initItem()

    return () => {
      if (CountdownRef.current) {
        clearInterval(CountdownRef.current)
      }
    }
  }, [id, initItem, navigate])
  useEffect(() => {
    if (!id) navigate(-1)
    window.scrollTo({ top: 0 })
    initItem()
  }, [location, id, initItem, navigate])

  useEffect(() => {
    if (offStatus.status === 'pending') {
      setOffCountdown(countdown(item?.off_date))
      CountdownRef.current = setInterval(() => {
        setOffCountdown(countdown(item?.off_date))
      }, 1000)
    }
    return () => {
      clearInterval(CountdownRef.current)
    }
  }, [offStatus, item?.off_date])

  const getLinkId = useCallback(
    (_link?: any) => {
      const __link = _link || item?.rlink || item?.link
      if (!__link) return messageApi.error('模板链接不存在请联系阿汪小助理进行处理！')
      if (item?.flowus) return __link
      const _id = __link.replace('https://httishere666.notion.site/', '')
      const _spits = _id.split('?')[0]
      setLinkId(_spits)
      return linkId
    },
    [item, linkId, messageApi]
  )

  // 点击拷贝模板按钮
  const handleDuplicate = useCallback(() => {
    if (openConfirm) return
    if (from === 'vip' && checkVIP()) {
    } else {
      if (lock) return
      if (item?.code && tempCode !== item?.code) return setIsCodeOpen(true)
    }
    setOpenConfirm(true)
    getLinkId()
  }, [from, getLinkId, item, lock, openConfirm, tempCode])
  // 点击拷贝到自己空间按钮
  const handleCopyOk = useCallback(
    (link_id?: string) => {
      console.log(link_id)
      if (lock) {
        messageApi.warning('该模板已被锁定')
        return true
      }
      // window?.splitbee.track('Duplicate template for free', { id, linkId: link_id || linkId, flowus: item?.flowus })
      if (item?.flowus) {
        window.open(item.rlink || item.link)
      } else {
        if (!link_id && !linkId) return
        window.open(
          `https://www.notion.so/${
            link_id || linkId
          }?duplicate=true&pvs=36&utm_source=public_page&utm_content=duplicate_button&from=public_page&n=duplicate_public_page`
        )
      }
    },
    [id, item, linkId, lock, messageApi]
  )

  const specContentCopy = (spec: any, modal: any) => {
    if (spec?.link) {
      window.open(spec?.link)
    }
    modal.destroy()
  }
  const handleBuy = useCallback(
    (spec?: any) => {
      console.log('handle buy')
      if (spec?.content) {
        const _content = spec.content.replace(/<br><\/br>/g, '\n')
        console.log(_content)
        const modal = Modal.success({
          title: spec.title,
          content: (
            <div className="mb-4">
              <p dangerouslySetInnerHTML={{ __html: spec?.content }} style={{ height: 200, overflow: 'hidden' }}></p>
              <p>...</p>
            </div>
          ),
          footer: (
            <>
              <CopyToClipboard text={_content} onCopy={() => specContentCopy(spec, modal)}>
                <Button type="primary" shape="round" block>
                  {spec?.link ? '打开链接' : '拷贝文字'}
                </Button>
              </CopyToClipboard>
            </>
          ),
          closable: true,
          onCancel: () => modal.destroy(),
        })
        return
      } else if (spec?.price <= 0 || spec?.link) {
        // window?.splitbee.track('Use trial template in detail', { id, title: item?.title })
        const modal = Modal.success({
          title: spec.title,
          content: <p>{spec?.remark}</p>,
          okText: '打开链接',
          onOk: () => {
            window.open(spec?.link)
            modal.destroy()
          },
          closable: true,
          onCancel: () => modal.destroy(),
        })
        return
      }
      if (offStatus.status === 'pending' && !spec?.m_pay_link && offStatus.realPrice === 0) {
        console.log(item.code, code, tempCode)
        if (item?.code !== code && item?.code !== tempCode) {
          return setIsCodeOpen(true)
        }
        return handleCopyOk(getLinkId(item?.rlink || item?.link))
      }
      if (is_weixn()) {
        return setShowWechatMark(true)
      }
      // window?.splitbee.track('Buy template in detail', { id, title: item?.title })
      console.log(item)
      if (item?.title?.indexOf('FlowUs') > -1) return window.open(item?.m_pay_link || item?.pay_link)
      if (isMobile) {
        if (item?.m_pay_link || item?.pay_link) {
          return window.open(item?.m_pay_link || item?.pay_link)
        } else {
          messageApi.error('模板链接不存在，请联系管理（httishere0728@gmail.com）获取帮助')
        }
      }
      setIsModalOpen(true)
    },
    [offStatus, item, code, getLinkId, handleCopyOk, id, isMobile, messageApi, tempCode]
  )
  const handleCopyCancel = () => {
    setIsModalOpen(false)
    setOpenConfirm(false)
  }
  const handleCodeComfirm = () => {
    if (item?.code !== tempCode) {
      return messageApi.error('模板口令不正确，请再次确认输入的口令')
    }
    setIsUnlocking(true)
    setIsCheck(true)
    setTimeout(() => {
      console.log(tempCode)
      setIsCodeOpen(false)
      setIsUnlocking(false)
      return messageApi.success('解锁成功，快去拷贝模板吧！')
    }, 3000)
  }

  const handleCodeChange = (e: { target: { value: SetStateAction<string> } }) => {
    setTempCode(e.target.value)
  }

  const handleCodeGetTip = () => {
    setIsCodeOpen(false)
    messageApi.info('请在小红书/B站三连后私信博主获取模板口令～')
  }

  const flexProps = isMobile
    ? {
        vertical: true,
        justify: 'start',
      }
    : {
        align: 'top',
        justify: 'space-between',
      }

  const Action = useMemo(() => {
    const has_pay = (item?.has_specs && item?.specs?.find((cur: any) => cur.price > 0)) || !item?.has_specs
    if (from === 'vip' && checkVIP()) {
      return (
        <Popconfirm
          placement={isMobile ? 'top' : 'leftTop'}
          title="模板使用"
          description={<UseSteps />}
          okText={'拷贝到自己空间'}
          cancelText="取消"
          onConfirm={() => handleCopyOk()}
          onCancel={handleCopyCancel}
        >
          <Button type="primary" shape="round" size="large" block className="w-1/3" onClick={handleDuplicate}>
            {'拷贝模板'}
          </Button>
        </Popconfirm>
      )
    } else {
      const buyBtn = (
        <Button danger type="primary" shape="round" size="large" className="w-auto" onClick={handleBuy}>
          {offStatus.status === 'pending' ? `${offCountdown} ${offStatus.realPrice ? '领券购买' : '限时领取'}` : '去购买'}
        </Button>
      )
      return (
        <>
          {item?.has_specs && (
            <Tooltip
              placement="topRight"
              color="#fff1f0"
              open
              title={
                item?.activity ? (
                  <p style={{ color: '#820014', textAlign: 'right' }}>
                    <Gift />
                    <span className="ml-3">{item.activity}</span>
                  </p>
                ) : (
                  <p className="text-black">多版本</p>
                )
              }
            >
              <div className="flex items-center flex-wrap">
                {item?.specs.map((spec: any) => (
                  <Tooltip title={spec?.remark}>
                    <Button
                      key={spec.title}
                      type="primary"
                      ghost={spec.price > 0}
                      danger={spec.price <= 0}
                      shape="round"
                      size="large"
                      className="ml-1 mb-2 w-auto"
                      onClick={() => handleBuy(spec)}
                    >
                      {spec.title}
                      {spec?.price > 0 && <strong className="text-rose-800 ml-2">¥{spec?.price}</strong>}
                    </Button>
                  </Tooltip>
                ))}
              </div>
            </Tooltip>
          )}
          {!item?.has_specs && (
            <>
              {!offStatus.status && item?.pay > 0 && (
                <h2 className="font-bold text-2xl text-rose-800">
                  ¥<span className="text-4xl">{item?.pay}</span>
                </h2>
              )}
              {(offStatus.status === 'pending' || offStatus.status === 'never') && (
                <h2 className="font-bold text-2xl text-rose-800">
                  ¥<span className="text-4xl">{offStatus.realPrice}</span>
                  <small className="opacity-50 line-through ml-4">¥{offStatus.pay}</small>
                </h2>
              )}
              {item?.activity && (
                <Tooltip
                  placement="left"
                  color="#fff1f0"
                  open
                  title={
                    <p style={{ color: '#820014', textAlign: 'right' }}>
                      <Gift />
                      <span className="ml-3">{item.activity}</span>
                    </p>
                  }
                >
                  {buyBtn}
                </Tooltip>
              )}
              {!item?.activity && item?.pay > 0 && <>{buyBtn}</>}
            </>
          )}
          {!item?.pay && has_pay && (
            // <Popconfirm
            //   className="bg-sky-50"
            //   trigger={'hover'}
            //   placement={'top'}
            //   title="模板使用"
            //   description={<UseSteps flowus={item?.flowus} />}
            //   okText={lock ? '该模板已被锁定' : '拷贝到自己空间'}
            //   cancelText="取消"
            //   onConfirm={() => handleCopyOk()}
            //   onCancel={handleCopyCancel}
            //   disabled={lock || (item?.code && tempCode !== item?.code)}
            // >
            <Button type="primary" shape="round" size="large" block className="w-1/3 mb-2" onClick={handleDuplicate} disabled={lock}>
              {lock ? '模板已被锁定' : '拷贝模板'}
            </Button>
            // </Popconfirm>
          )}
        </>
      )
    }
  }, [
    item,
    from,
    handleBuy,
    handleCopyOk,
    handleDuplicate,
    isMobile,
    lock,
    offCountdown,
    offStatus.pay,
    offStatus.realPrice,
    offStatus.status,
  ])

  const ReturnButton = (
    <Button type="primary" shape="round" onClick={() => navigate('/picks')}>
      返回模版库
    </Button>
  )

  const resultProps: any = {
    status: '404',
    title: '404',
    subTitle: '没找到该模板',
    extra: ReturnButton,
  }

  return (
    <div key={id}>
      {contextHolder}
      {result === '404' && <Result {...resultProps} />}
      {result === 'default' && (
        <Flex {...flexProps}>
          <Col span={isMobile ? 24 : 16}>
            <h2 className="font-bold text-2xl">{item?.full_title || item?.title}</h2>
            <Space align="center" className="text-gray-400 pt-2">
              {item?.created && (
                <span className={`${isMobile ? 'hidden' : ''}`}>{moment(Number(item?.created)).format('YYYY/MM/DD HH:mm')}</span>
              )}
              <span className={`${isMobile ? 'hidden' : ''}`}>
                <Rate disabled defaultValue={star} />
              </span>
              <span>❗️模板仅供个人学习使用，请勿二传二改或商用</span>
              <span className={`${isMobile ? 'hidden' : ''}`}>
                <EyeOutlined className="mr-1" />
                {item?.views}
              </span>
            </Space>
            <div className="mt-8 mb-8 rounded-xl overflow-hidden max-h-120 bg-slate-300">
              {item?.video && (
                <iframe
                  title="video"
                  className={`w-full ${isMobile ? 'h-60' : 'h-120'}`}
                  src={item.video}
                  frameBorder="no"
                  allowFullScreen={true}
                />
              )}
              {!item?.video && !item?.images && <Image className="w-full h-full" src={item?.cover} />}
            </div>
            {!item?.video && item?.images && (
              <div className="m-auto mt-8 mb-8 overflow-hidden flex justify-center">
                {!isMobile && <Image className="max-w-90 h-120 rounded-xl mr-4" src={item?.cover} />}
                <Carousel autoplay className="w-90 h-120 max-w-90 rounded-xl ">
                  {item.images.map((current: string) => (
                    <div key={current} className="w-full h-full block">
                      <Image src={current} className="w-full h-full block rounded-xl" />
                    </div>
                  ))}
                </Carousel>
              </div>
            )}
            {!isMobile && <div id="waline"></div>}
          </Col>
          <Col span={isMobile ? 24 : 7}>
            {!isMobile && <Author />}
            <div className={`mt-8 ${isMobile ? 'pl-2 pr-2' : ''}`}>
              <div className="flex items-center justify-between">{Action}</div>
              <div className="mt-2 mb-8 leading-8 text-base">
                {item?.keywords && item.keywords.map((tag: string | undefined) => <Tag color="blue">{tag}</Tag>)}
                <p dangerouslySetInnerHTML={{ __html: item?.detail || item?.description }} />
              </div>
              <PickListCard />
            </div>
          </Col>
        </Flex>
      )}
      {/* code modal */}
      <Modal
        title="该模板为限定分享模板"
        centered
        open={isCodeOpen}
        onOk={handleCodeComfirm}
        onCancel={handleCodeGetTip}
        cancelText="如何获取模板口令？"
        okText={isUnlocking ? '解锁中' : '确定'}
        confirmLoading={isUnlocking}
      >
        <Input placeholder="请输入模板口令" defaultValue={code} onChange={handleCodeChange} />
      </Modal>
      {/* buy modal */}
      <Modal
        width={300}
        title="手机淘宝扫一扫"
        open={isModalOpen}
        okText="好的"
        cancelText="取消"
        onOk={handleCopyCancel}
        onCancel={handleCopyCancel}
      >
        {item?.pay_img && <Image width={250} src={item?.pay_img} />}
        {!item?.pay_img && <QRCode className="m-auto" value={item?.m_pay_link} />}
        <p className="text-center font-bold text-rose-900">
          <ExclamationCircleFilled className="mr-1" />
          下单后在淘宝客服消息获取模板
        </p>
      </Modal>

      {showWechatMark && (
        <div className={styles.wechatMarkBox} onClick={() => setShowWechatMark(false)}>
          <div className={styles.wechatMarkBox_Content}>
            <img src={ArrowImg} className={styles.arrow} alt="" />
            <p>
              1️⃣ 点击右上角的
              <EllipsisOutlined />
              按钮
            </p>
            <p>
              2️⃣ 选择在 <GlobalOutlined /> 默认浏览器浏览器打开
            </p>
          </div>
        </div>
      )}

      <Modal
        open={openConfirm}
        okText={lock ? '该模板已被锁定' : '拷贝到自己空间'}
        cancelText="取消"
        onOk={() => handleCopyOk()}
        onCancel={handleCopyCancel}
        centered
      >
        <h2 className="text-xl font-bold mb-4">模板拷贝使用</h2>
        <UseSteps flowus={item?.flowus} />
      </Modal>
    </div>
  )
}
